// // src/pages/SignupPage.jsx
// import { useState } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";

// export default function SignupPage() {
//   const [form, setForm] = useState({ firstName: "", lastName: "", email: "", password: "", confirm: "" });
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const { signup } = useAuth();
//   const navigate = useNavigate();

//   function update(field) {
//     return (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));
//   }

//   // // async function handleSubmit(e) {
//   // //   e.preventDefault();
//   // //   setError("");
//   // //   if (form.password !== form.confirm) { setError("Passwords do not match."); return; }
//   // //   if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
//   // //   setLoading(true);
//   // //   try {
//   // //     await signup(form.firstName, form.lastName, form.email, form.password);
//   // //     navigate("/dashboard");
//   // //   } catch (err) {
//   // //     const msg = err.code === "auth/email-already-in-use"
//   // //       ? "An account with this email already exists."
//   // //       : "Failed to create account. Please try again.";
//   // //     setError(msg);
//   // //   }
//   // //   setLoading(false);
//   // // }

//   // In SignupPage.jsx — find handleSubmit and update:
// async function handleSubmit(e) {
//   e.preventDefault();
//   setError("");
//   if (form.password !== form.confirm) { setError("Passwords do not match."); return; }
//   if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
//   setLoading(true);
//   try {
//     await signup(form.firstName, form.lastName, form.email, form.password);
//     navigate("/verify-email"); // ← redirect to verify page instead of dashboard
//   } catch (err) {
//     const msg = err.code === "auth/email-already-in-use"
//       ? "An account with this email already exists."
//       : "Failed to create account. Please try again.";
//     setError(msg);
//   }
//   setLoading(false);
// }

//   return (
//     <div style={{ minHeight: "100vh", background: "var(--gray-50)", display: "flex", flexDirection: "column" }}>
//       <nav style={{ borderBottom: "1px solid var(--gray-200)", padding: "0 32px", height: 60, display: "flex", alignItems: "center", background: "#fff" }}>
//         <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <div style={{ width: 30, height: 30, background: "var(--blue)", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ color: "#fff", fontSize: 14 }}>📄</span>
//           </div>
//           <span style={{ fontWeight: 700, fontSize: 16 }}>ResumeScore<span style={{ color: "var(--blue)" }}>AI</span></span>
//         </Link>
//       </nav>

//       <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
//         <div style={{ width: "100%", maxWidth: 440 }}>
//           <div className="card" style={{ padding: "36px 32px" }}>
//             <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.02em" }}>Create your account</h1>
//             <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 28 }}>Start analyzing your resume in minutes</p>

//             {error && (
//               <div style={{ background: "var(--red-light)", color: "var(--red)", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 20, border: "1px solid #f0a0a0" }}>
//                 {error}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>
//               <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
//                 <div className="form-group" style={{ margin: 0 }}>
//                   <label>First name</label>
//                   <input className="form-input" type="text" placeholder="Jane" value={form.firstName} onChange={update("firstName")} required />
//                 </div>
//                 <div className="form-group" style={{ margin: 0 }}>
//                   <label>Last name</label>
//                   <input className="form-input" type="text" placeholder="Smith" value={form.lastName} onChange={update("lastName")} required />
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label>Email address</label>
//                 <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={update("email")} required />
//               </div>
//               <div className="form-group">
//                 <label>Password</label>
//                 <input className="form-input" type="password" placeholder="At least 6 characters" value={form.password} onChange={update("password")} required />
//               </div>
//               <div className="form-group">
//                 <label>Confirm password</label>
//                 <input className="form-input" type="password" placeholder="Repeat your password" value={form.confirm} onChange={update("confirm")} required />
//               </div>
//               <button className="btn btn-primary btn-full btn-lg" type="submit" disabled={loading} style={{ marginTop: 8 }}>
//                 {loading ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Creating account...</> : "Create Account"}
//               </button>
//             </form>

//             <p style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 16, textAlign: "center" }}>
//               By signing up, you agree to our Terms of Service and Privacy Policy.
//             </p>
//           </div>

//           <p style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: "var(--gray-600)" }}>
//             Already have an account?{" "}
//             <Link to="/login" style={{ color: "var(--blue)", fontWeight: 500 }}>Sign in | </Link>
//               <Link to="/forgot-password" style={{ color: "var(--blue)", fontWeight: 500 }}> Forgot password?</Link>

//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }

// new code
// src/pages/SignupPage.jsx
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
// eslint-disable-next-line no-unused-vars
import { sendEmailVerification } from "firebase/auth";
// eslint-disable-next-line no-unused-vars
import { auth } from "../utils/firebase";

export default function SignupPage() {
  const [form, setForm]       = useState({ firstName: "", lastName: "", email: "", password: "", confirm: "" });
  const [error, setError]     = useState("");
  const [loading, setLoading] = useState(false);
  const { signup }            = useAuth();
  const navigate              = useNavigate();

  function update(field) {
    return (e) => setForm(prev => ({ ...prev, [field]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (form.password !== form.confirm) { setError("Passwords do not match."); return; }
    if (form.password.length < 6)       { setError("Password must be at least 6 characters."); return; }

    setLoading(true);
    try {
      // Create the account
      await signup(form.firstName, form.lastName, form.email, form.password);

      // // Send Firebase verification email — one line, Firebase handles everything
      // const currentUser = auth.currentUser;
      // if (currentUser && !currentUser.emailVerified) {
      //   await sendEmailVerification(currentUser);
      // }

      // Redirect to a "check your email" page instead of dashboard
      navigate("/verify-email");

    } catch (err) {
      const msg = err.code === "auth/email-already-in-use"
        ? "An account with this email already exists."
        : err.code === "auth/invalid-email"
        ? "Please enter a valid email address."
        : err.code === "auth/weak-password"
        ? "Password must be at least 6 characters."
        : "Failed to create account. Please try again.";
      setError(msg);
    }
    setLoading(false);
  }

  return (
    <div style={{ minHeight: "100vh", background: "var(--gray-50)", display: "flex", flexDirection: "column" }}>
      <nav style={{ borderBottom: "1px solid var(--gray-200)", padding: "0 32px", height: 60, display: "flex", alignItems: "center", background: "#fff" }}>
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 8, textDecoration: "none" }}>
          <div style={{ width: 30, height: 30, background: "#2563eb", borderRadius: 7, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontWeight: 800, fontSize: 14 }}>R</span>
          </div>
          <span style={{ fontWeight: 700, fontSize: 16, color: "#1e293b" }}>ResumeScore<span style={{ color: "#2563eb" }}>AI</span></span>
        </Link>
      </nav>

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 16px" }}>
        <div style={{ width: "100%", maxWidth: 440 }}>
          <div className="card" style={{ padding: "36px 32px" }}>
            <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 6, letterSpacing: "-0.02em" }}>Create your account</h1>
            <p style={{ fontSize: 14, color: "var(--gray-500)", marginBottom: 28 }}>Start analyzing your resume in minutes</p>

            {error && (
              <div style={{ background: "#fef2f2", color: "#dc2626", fontSize: 13, padding: "10px 14px", borderRadius: 8, marginBottom: 20, border: "1px solid #fecaca" }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                <div className="form-group" style={{ margin: 0 }}>
                  <label>First name</label>
                  <input className="form-input" type="text" placeholder="Jane" value={form.firstName} onChange={update("firstName")} required />
                </div>
                <div className="form-group" style={{ margin: 0 }}>
                  <label>Last name</label>
                  <input className="form-input" type="text" placeholder="Smith" value={form.lastName} onChange={update("lastName")} required />
                </div>
              </div>

              <div className="form-group">
                <label>Email address</label>
                <input className="form-input" type="email" placeholder="you@example.com" value={form.email} onChange={update("email")} required />
              </div>

              <div className="form-group">
                <label>Password</label>
                <input className="form-input" type="password" placeholder="At least 6 characters" value={form.password} onChange={update("password")} required />
                {/* Password strength indicator */}
                {form.password.length > 0 && (
                  <div style={{ marginTop: 6 }}>
                    <div style={{ display: "flex", gap: 4, marginBottom: 4 }}>
                      {[1,2,3,4].map(i => {
                        const strength = form.password.length >= 10 && /[A-Z]/.test(form.password) && /[0-9]/.test(form.password) ? 4
                                       : form.password.length >= 8 && (/[A-Z]/.test(form.password) || /[0-9]/.test(form.password)) ? 3
                                       : form.password.length >= 6 ? 2
                                       : 1;
                        const color = strength === 4 ? "#059669"
                                    : strength === 3 ? "#2563eb"
                                    : strength === 2 ? "#d97706"
                                    : "#dc2626";
                        return (
                          <div key={i} style={{ flex: 1, height: 3, borderRadius: 2, background: i <= strength ? color : "#e2e8f0", transition: "background 0.2s" }} />
                        );
                      })}
                    </div>
                    <div style={{ fontSize: 11, color:
                      form.password.length >= 10 && /[A-Z]/.test(form.password) && /[0-9]/.test(form.password) ? "#059669"
                      : form.password.length >= 8 ? "#2563eb"
                      : form.password.length >= 6 ? "#d97706"
                      : "#dc2626"
                    }}>
                      {form.password.length >= 10 && /[A-Z]/.test(form.password) && /[0-9]/.test(form.password) ? "Strong password"
                       : form.password.length >= 8 && (/[A-Z]/.test(form.password) || /[0-9]/.test(form.password)) ? "Good — add numbers or uppercase for stronger"
                       : form.password.length >= 6 ? "Weak — try a longer password"
                       : "Too short — minimum 6 characters"}
                    </div>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Confirm password</label>
                <input
                  className="form-input"
                  type="password"
                  placeholder="Repeat your password"
                  value={form.confirm}
                  onChange={update("confirm")}
                  required
                  style={{
                    borderColor: form.confirm && form.confirm !== form.password ? "#fca5a5"
                               : form.confirm && form.confirm === form.password ? "#86efac"
                               : undefined
                  }}
                />
                {form.confirm && form.confirm !== form.password && (
                  <div style={{ fontSize: 11, color: "#dc2626", marginTop: 4 }}>Passwords do not match</div>
                )}
                {form.confirm && form.confirm === form.password && (
                  <div style={{ fontSize: 11, color: "#059669", marginTop: 4 }}>✓ Passwords match</div>
                )}
              </div>

              <button
                className="btn btn-primary btn-full btn-lg"
                type="submit"
                disabled={loading || (form.confirm && form.confirm !== form.password)}
                style={{ marginTop: 8 }}
              >
                {loading
                  ? <><span className="spinner" style={{ width: 16, height: 16 }} /> Creating account...</>
                  : "Create Account"}
              </button>
            </form>

            {/* What happens next — sets expectation about verification email */}
            <div style={{ marginTop: 20, background: "#f8fafc", borderRadius: 10, padding: "12px 14px", border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>
                <strong style={{ color: "#374151" }}>What happens next:</strong> We'll send a verification email to confirm your address. Check your inbox (and spam folder) after signing up.
              </div>
            </div>

            <p style={{ fontSize: 12, color: "var(--gray-500)", marginTop: 14, textAlign: "center" }}>
              By signing up, you agree to our{" "}
              <Link to="/terms" style={{ color: "#2563eb" }}>Terms of Service</Link> and{" "}
              <Link to="/privacy" style={{ color: "#2563eb" }}>Privacy Policy</Link>.
            </p>
          </div>

          <p style={{ textAlign: "center", marginTop: 20, fontSize: 14, color: "var(--gray-600)" }}>
            Already have an account?{" "}
            <Link to="/login" style={{ color: "#2563eb", fontWeight: 500 }}>Sign in</Link>
            {" · "}
            <Link to="/forgot-password" style={{ color: "#2563eb", fontWeight: 500 }}>Forgot password?</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
